import { Container } from "./noData.styles";
import NoDataImg from "../../assets/images/nodata.svg";
import Image from "../Image/Image.component";
type NoDataProps = {
  message: string;
  className?: string;
  img?: string;
};
const NoData = ({ message, className, img }: NoDataProps) => {
  return (
    <Container>
      {/* <NoDataImage alt="No Data" draggable={false} /> */}
      <Image
        src={img ? img : NoDataImg}
        addBaseLink={false}
        alt="No Data"
        className={className ? className : "w-full"}
      />
      <h1>{message}</h1>
    </Container>
  );
};
export default NoData;
